var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRangeBinning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 2v1.125h-2.25v9.75h2.25V14h-2.25A1.125 1.125 0 012 12.875v-9.75C2 2.504 2.504 2 3.125 2zM14 12.875c0 .58-.439 1.057-1.002 1.118l-.123.007h-2.25v-1.125h2.25v-9.75h-2.25V2h2.25C13.496 2 14 2.504 14 3.125zM8.234 4.64c.588 0 1.098.1 1.531.298.433.198.767.48 1 .844.235.365.352.797.352 1.296 0 .5-.119.93-.356 1.292a2.26 2.26 0 01-1.01.83l1.489 2.16H9.59L8.31 9.488H6.895v1.872H5.36V4.64zm-.086 1.267H6.896V8.25h1.252c.462 0 .813-.103 1.053-.308.24-.204.36-.492.36-.864 0-.377-.12-.667-.36-.868-.24-.202-.591-.303-1.053-.303z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangeBinning);
export default __webpack_public_path__ + "static/media/range-binning.05c076ffdfda44a5f50a24e9d05c0ec8.svg";
export { ForwardRef as ReactComponent };